<!--登录组件-->
<template>
  <div class="login-content">
    <div class="login-logo">
      <img src="@/assets/bayer-logo.svg" />
    </div>
    <div class="login-title">Smart Label Recognition</div>
    <div class="login-detail">
      <v-form ref="form" v-model="valid">
        <v-flex xs12>
          <div class="login-head">{{ this.$t('logintitle') }}</div>
        </v-flex>
        <div class="login-body">
          <v-flex xs12>
            <v-text-field
              v-model="base.loginuser.userName"
              :rules="nameRules"
              prepend-inner-icon="mdi-account"
              :label="this.$t('username')"
              required
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              v-model="base.loginuser.password"
              :rules="nameRules"
              prepend-inner-icon="mdi-lock"
              :label="this.$t('password')"
              type="password"
              required
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-btn
              @click="login()"
              class="login"
              style="background:#1cade4"
              depressed
              >{{ this.$t('login') }}</v-btn
            >
          </v-flex>
          <v-flex xs12 v-if="msg == ''">
            <core-progress ref="process" />
          </v-flex>
          <v-flex xs12>
            <div class="loginerror" :title="msg" v-if="msg != ''">
              {{ msg }}
            </div>
          </v-flex>
        </div>
      </v-form>
    </div>
  </div>
</template>
<script>
import { post } from '@/request/http'
import { mapState } from 'vuex'
import CoreProgress from '@/components/core/progress.vue'
import { PowerSeeting } from '@/common/common'
export default {
  components: {
    CoreProgress
  },
  data: () => ({
    valid: true,
    username: '',
    password: '',
    query: true,
    show: true,
    msg: '',
    url: process.env.VUE_APP_TOKEN_API + '/token/issue/'
  }),
  created: function() {
    let loginuser = JSON.parse(localStorage.getItem('loginuser'))
    if (loginuser != null && loginuser.Roles.length > 0) {
      this.$router.push('index')
    }
  },
  computed: {
    ...mapState({
      base: state => state.base
    }), //不为空校验规则
    nameRules() {
      let _this = this
      return [v => !!v || _this.$t('error.empty')]
    }
  },
  methods: {
    login() {
      if (this.$refs.form.validate()) {
        let _this = this
        this.msg = '正在登录...'
        let param = {
          userName: this.base.loginuser.userName,
          password: this.base.loginuser.password,
          t: new Date().getTime()
        }
        post(this.url, param).then(res => {
          var data = res.data
          if (data.IsSuccess) {
            if (data.Roles != null && data.Roles.length > 0) {
              _this.base.loginuser.Name = data.Name
              _this.base.loginuser.token = data.Token
              _this.base.loginuser.Roles = PowerSeeting(data.Roles)
              localStorage.setItem(
                'loginuser',
                JSON.stringify(this.base.loginuser)
              )
              localStorage.setItem('Token', data.Token)
              this.$router.push('index')
            } else {
              this.msg = '无访问权限,请联系管理员'
            }
          } else {
            this.msg = '账号或密码不对，请检查'
          }
        })
      }
    }
  }
}
</script>
<style>
.login-logo {
  width: 120px;
  height: 120px;
}
.login-title {
  padding: 22px 10px 10px 30px;
  font-size: 30px;
  color: white;
  margin-bottom: 30px;
}
.login-content {
  background: #1cade4;
  background: -webkit-gradient(
    linear,
    left top,
    right bottom,
    color-stop(0%, #1cade4),
    color-stop(100%, #47c079)
  );
  width: 100%;
  height: 100%;
  justify-content: center;
  display: flex;
  display: -webkit-inline-box; /* Fix Safari rendering issue on iOS 10 */
  align-items: center;
  flex-direction: column;
}
.login-detail {
  background-color: white;
  width: 400px;
  height: 350px;
  border: 1px solid white;
  border-radius: 10px;
}
.login-head {
  height: 60px;
  padding-top: 20px;
  line-height: 60px;
  margin-bottom: 15px;
  font-size: 22px;
}
.login-body {
  padding-left: 100px;
  padding-right: 100px;
  padding-top: 15px;
}
.loginerror {
  color: #f55a4e;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-top: 10px;
  font-size: 12px;
}
.login {
  width: 100%;
  margin-left: 0px;
  margin-top: 30px;
}
</style>
<i18n>
{
    "en": {
        "logintitle": "User Login",
        "username": "User Name",
        "password":"password",
        "login":"Login"
  },
    "cn": {
        "logintitle": "用户登录",
        "username": "用户名",
        "password":"密码",
        "login":"登录"
      }
  }
</i18n>
